import React from 'react'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from 'src/component/ui/dialog'
import { Drawer, DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerTitle } from 'src/component/ui/drawer'
import { OutlinedButton, PrimaryButton } from 'src/component/ui/button'
import { useMediaQuery } from 'src/hook/use-media-query'

export type CloseAppTourDialogProps = {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
}

const description = (
  <p className="text-mist font-roboto-condensed text-base tracking-wide leading-relaxed text-center">
    You can dive in on your own now - everything&apos;s ready for you.
  </p>
)

const footerActionsClass = 'flex flex-wrap gap-3 justify-center w-full sm:w-auto sm:justify-center'
const cancelButtonClass = 'px-8 md:px-10 text-primary'
const confirmButtonClass = 'px-8 md:px-10'

export const CloseAppTourDialog = ({ isOpen, onConfirm, onCancel }: CloseAppTourDialogProps): React.ReactElement => {
  const isMobile = useMediaQuery('(max-width: 992px)')

  const handleOpenChange = (open: boolean): void => {
    if (!open) onCancel()
  }

  if (isMobile) {
    return (
      <Drawer open={isOpen} onOpenChange={handleOpenChange}>
        <DrawerContent className="bg-secondary-gray px-6 pb-8 border-0" style={{ pointerEvents: 'auto' }}>
          <DrawerHeader className="text-center space-y-4">
            <DrawerTitle className="font-evogria text-ivory text-2xl uppercase leading-tight font-normal">
              Close{' '}
              <span className="font-evogria text-primary text-2xl md:text-4xl uppercase leading-tight font-normal">Tour?</span>
            </DrawerTitle>
            <DrawerDescription asChild>{description}</DrawerDescription>
          </DrawerHeader>
          <DrawerFooter className="flex-col sm:flex-row flex-wrap justify-center gap-3 pt-2 pb-0">
            <div className={footerActionsClass}>
              <OutlinedButton type="button" className={cancelButtonClass} onClick={onCancel}>
                Cancel
              </OutlinedButton>
              <PrimaryButton type="button" className={confirmButtonClass} onClick={onConfirm}>
                Let&apos;s go!
              </PrimaryButton>
            </div>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    )
  }

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="bg-secondary-gray border-0 max-w-md gap-6" style={{ pointerEvents: 'auto' }}>
        <DialogHeader className="text-center space-y-4 sm:text-center">
          <DialogTitle className="font-evogria text-ivory text-2xl md:text-4xl uppercase leading-tight font-normal">
            Close{' '}
            <span className="font-evogria text-primary text-2xl md:text-4xl uppercase leading-tight font-normal">Tour?</span>
          </DialogTitle>
          <DialogDescription asChild>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col sm:flex-row gap-3 sm:justify-center sm:space-x-0">
          <div className={footerActionsClass}>
            <OutlinedButton type="button" className={cancelButtonClass} onClick={onCancel}>
              Cancel
            </OutlinedButton>
            <PrimaryButton type="button" className={confirmButtonClass} onClick={onConfirm}>
              Let&apos;s go!
            </PrimaryButton>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
